/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { GetMessageStatus1QueryResponse, GetMessageStatus1PathParams, GetMessageStatus1400, GetMessageStatus1401, GetMessageStatus1404, GetMessageStatus1409, GetMessageStatus1500 } from "../../types/GetMessageStatus1.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getGetMessageStatus1Url(messageId: GetMessageStatus1PathParams["messageId"]) {
  const res = { method: 'GET', url: `/api/research-chat/message/${messageId}/status` as const }
  return res
}

/**
 * @summary Poll message processing status
 * {@link /api/research-chat/message/:messageId/status}
 */
export async function getMessageStatus1(messageId: GetMessageStatus1PathParams["messageId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetMessageStatus1QueryResponse, ResponseErrorConfig<GetMessageStatus1400 | GetMessageStatus1401 | GetMessageStatus1404 | GetMessageStatus1409 | GetMessageStatus1500>, unknown>({ method : "GET", url : getGetMessageStatus1Url(messageId).url.toString(), ... requestConfig })
  return res.data
}